import { useContext } from 'react';

import AppContext from 'context';
import useTracking, { initAmplitude } from './useTracking';
import useFeatureToggle from './useFeatureToggle';
import useMenuAccess from './useMenuAccess';
import useBrowserNotification from './useBrowserNotification';

export const useGlobals = () => {
  const { state, dispatch } = useContext(AppContext);

  const { hasAccessToMenu } = useMenuAccess();

  return {
    dispatchToGlobal: dispatch,
    user: state?.user,
    traffic: state?.traffic,
    features: state?.features,
    truckerProfile: state?.truckerProfile,
    planMigration: state?.planMigration,
    initAmplitude,
    amplitude: useTracking,
    featureToggles: useFeatureToggle,
    planUpgradeNotify: hasAccessToMenu,
    isShowNewHorizontal: true,
    foco: state?.foco,
    planMigrationSource: state?.planMigrationSource,
    notificationBrowser: useBrowserNotification,
  };
};

export default useGlobals;
